'use es6';

import PropTypes from 'prop-types';
export const ACTION_LOCATIONS = {
  SINGLE_ASSET_VIEW: 'single-asset-view',
  ASSET_LIST_PAGE: 'asset-list-page'
};
export const ActionLocationPropType = PropTypes.oneOf(Object.values(ACTION_LOCATIONS));